import React from "react";
import { connect, getIn } from "formik";

import { DatePicker, Form } from 'antd';
const FormItem = Form.Item;

class MyDatePicker extends React.Component {
    handleChange = (value, valueString) => {
        this.props.onChange(this.props.name, value);
    };

    handleBlur = () => {
        this.props.onBlur(this.props.name, true);
    };

    render() {
        const error = getIn(this.props.formik.errors, this.props.name);
        const touched = getIn(this.props.formik.touched, this.props.name);

        return (
            <React.Fragment>
                <FormItem
                    className="mb-0"
                    hasFeedback={false}
                    validateStatus={touched && error ? "error" : ""}
                    help={touched && error ? error : ""}
                >
                    <DatePicker {...this.props} onChange={this.handleChange} onBlur={this.handleBlur} />
                </FormItem>
            </React.Fragment>
        );
    }
}

export default connect(MyDatePicker);